export const MENU_ITEMS_TO_CREATE: string[] = [
  'MEMBERS_LOGIN_ICONS_MENU',
  'MEMBERS_LOGIN_MENU',
];
